import type { Theme } from '@mui/material/styles'
import { navigationWidthStyles } from '../BottomNavigation/bottomNavigation.styles'

const styles = {
  root: {
    backgroundColor: 'neutral.black',
    width: '100%',
    paddingTop: 'var(--spacing-l)',
    paddingBottom: 0,
    '& .hidden': {
      display: 'none',
    },

    '& #p-banner-button': {
      width: { xs: 80, md: 96 },
      height: 'var(--size-buttonM)',
      borderStyle: 'none',
      borderRadius: 'var(--corners-m)',
      fontWeight: 'var(--typography-fontWeight-semiBold)',
      cursor: 'pointer',
      color: 'neutral.black',
      backgroundColor: 'neutral.white',
      '&:hover': {
        backgroundColor: 'neutral.lightest',
      },
    },
  },
  bannerBox: {
    height: 'fit-content',
    ...navigationWidthStyles,
    marginInline: 'auto',
    paddingBlock: 'var(--spacing-m)',
    paddingInline: 'var(--spacing-l)',
    backgroundColor: 'primary.main',
    color: 'neutral.black',
    borderRadius: 'var(--corners-m)',
    textAlign: 'center',
    fontSize: '0.875em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: 'var(--spacing-m)',

    // El message puede llegar como HTML crudo (Banner/index.tsx): estas reglas
    // blindan sus tags contra los selectores de tag del periódico (!important).
    '& p, & ul, & ol, & li, & h1, & h2, & h3, & h4, & h5, & h6, & blockquote, & strong, & b, & em, & i':
      {
        fontFamily: 'inherit !important',
        fontSize: 'inherit !important',
        lineHeight: 'inherit !important',
        letterSpacing: 'inherit !important',
        color: 'inherit !important',
      },
    '& p, & ul, & ol, & blockquote, & h1, & h2, & h3, & h4, & h5, & h6': {
      margin: '0 !important',
    },
    '& ul, & ol': {
      paddingInlineStart: '1.25em !important',
    },
    '& strong, & b': {
      fontWeight: '700 !important',
    },
    '& em, & i': {
      fontStyle: 'italic !important',
    },
    '& a': {
      color: 'inherit !important',
      textDecorationColor: 'currentColor !important',
      fontWeight: '500 !important',
    },
  },
  arrowAnchor: {
    marginInline: 'auto',
    height: '10px',
    width: {
      xs: '100%',
      md: `calc((var(--spacing-l) * 4) + (var(--size-buttonL) * 5))`,
    },
    maxWidth: 'calc(100% - 3em)',

    '& > div': {
      marginInline: 'auto',
      content: '""',
      width: 0,
      height: 0,
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      borderTop: (theme: Theme) => `10px solid ${theme.palette.primary.main}`,
    },
  },
}

export default styles
